export default {
  required: {
    mobile: 'رقم الجوال الجديد مطلوب',
    email: 'البريد الإلكتروني مطلوب',
    placeOfPractice: 'مكان العمل مطلوب',
    qualification: 'المؤهل العلمي مطلوب',
    iban: 'رقم الآيبان مطلوب',
    schsRegistration: 'رقم تسجيل الهيئة السعودية للتخصصات الصحية مطلوب',
    schsExpiry: 'تاريخ انتهاء تسجيل الهيئة السعودية للتخصصات الصحية مطلوب',
    city: 'المدينة مطلوبة',
    district: 'الحي مطلوب',
    street: 'الشارع مطلوب',
    buildingNumber: 'رقم المبنى مطلوب',
    zipCode: 'الرمز البريدي مطلوب',
    additionalNumber: 'الرقم الإضافي مطلوب',
    certificate: 'شهادة العنوان الوطني مطلوبة',
  },
  certificate: {
    fileType: 'أنواع الملفات المقبولة: JPG، JPEG، PNG',
    fileSize: 'الحد الأقصى لحجم الملف 15 ميجابايت',
  },
  format: {
    email: 'ادخل بريد الكترونى صحيح',
    mobile:
      'يرجى إدخال رقم جوال صحيح يبدأ بـ 05 متبوع بـ 8 أرقام (أرقام إنجليزية فقط)',
  },
  checkbox: {
    accept: 'يجب الموافقة على جميع الشروط والأحكام',
  },
  maxLength: 'يجب أن لا يتجاوز {{length}} حرف',
  mustBeNumber: 'يجب أن يكون رقماً صالحاً',
  onlyNumericAllowed: 'يسمح بالأرقام فقط',
  onlyAlphanumericAllowed: 'يسمح بالأحرف والأرقام فقط',
  onlyNumericMaxLength: 'الحد الأقصى هو {{length}} أرقام',
  onlyCharMaxLength: 'الحد الأقصى هو {{length}} حرف',
  mustBePositive: 'يجب أن يكون رقماً موجباً',
  mustBeNonNegative: 'يجب أن يكون صفر أو رقماً موجباً',
  mustBeInteger: 'يجب أن يكون رقماً صحيحاً',
  facilityNameLength:
    'رجاء إدخال 3 حروف على الأقل و 100 حرف بحد أقصى لإسم جهة العمل',
  schsRegistrationNumberLength:
    'يجب أن لا يتجاوز {{length}} حرف لرقم تسجيل الهيئة السعودية للتخصصات الصحية',
} as const
